import { Box } from "@mui/material";
import { keyframes } from "@mui/system";

type AuthLoadingStateProps = {
  loadingLabel?: string;
};

// Most session checks finish in well under the delay, so the splash never
// appears at all; a slow one gets a quiet logo rather than a flash of the
// login page (which a signed-in user should never see).
const SPLASH_DELAY_MS = 300;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(0.94); }
`;

const AuthLoadingState = ({
  loadingLabel = "Loading account...",
}: AuthLoadingStateProps) => (
  <Box
    role="status"
    aria-label={loadingLabel}
    sx={{
      position: "fixed",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "background.default",
    }}
  >
    <Box
      component="img"
      src="/logo512.png"
      alt=""
      data-testid="auth-loading-logo"
      sx={{
        width: 48,
        height: 48,
        borderRadius: "12px",
        opacity: 0,
        animation: `${fadeIn} 240ms ease-out ${SPLASH_DELAY_MS}ms forwards, ${pulse} 1.6s ease-in-out ${SPLASH_DELAY_MS}ms infinite`,
        "@media (prefers-reduced-motion: reduce)": {
          animation: `${fadeIn} 240ms ease-out ${SPLASH_DELAY_MS}ms forwards`,
        },
      }}
    />
  </Box>
);

export default AuthLoadingState;
